import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import api from '../utils/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Ingresa tu correo electrónico');
      return;
    }

    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
      toast.success('Revisa tu correo electrónico');
    } catch (error) {
      // Always show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F5F5F0' }}>
        <div className="bg-white border border-border shadow-sm rounded-lg p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#E8F5E9' }}>
            <CheckCircle className="w-8 h-8" style={{ color: '#1A4D2E' }} />
          </div>
          
          <h1 className="text-2xl font-bold mb-4" style={{ color: '#1A4D2E' }}>
            Revisa tu correo
          </h1>
          
          <p className="text-gray-600 mb-6">
            Si existe una cuenta con <strong>{email}</strong>, recibirás un enlace para restablecer tu contraseña.
          </p>
          
          <p className="text-sm text-gray-500 mb-6">
            El enlace expira en 1 hora. Revisa también tu carpeta de spam.
          </p>
          
          <div className="space-y-3">
            <Button
              onClick={() => setSent(false)}
              variant="outline"
              className="w-full"
            >
              Enviar de nuevo
            </Button>
            
            <Link to="/login" className="block">
              <Button 
                className="w-full"
                style={{ backgroundColor: '#1A4D2E' }}
              >
                Volver al inicio de sesión
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F5F5F0' }}>
      <div className="bg-white border border-border shadow-sm rounded-lg p-8 max-w-md w-full">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6">
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio de sesión
        </Link>
        
        <div className="text-center mb-8">
          <img src="/assets/logo.png" alt="contractcheck360" className="h-12 w-auto mx-auto mb-4" />
          <h1 className="text-2xl font-bold" style={{ color: '#1A4D2E' }}>
            ¿Olvidaste tu contraseña?
          </h1>
          <p className="text-gray-600 mt-2">
            Ingresa tu correo y te enviaremos un enlace para restablecerla
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Correo Electrónico
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                className="pl-10"
                data-testid="forgot-email-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full"
            style={{ backgroundColor: '#1A4D2E' }}
            data-testid="forgot-submit-btn"
          >
            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </Button>
        </form>

        <p className="text-center text-sm text-gray-600 mt-6">
          ¿Recordaste tu contraseña?{' '}
          <Link to="/login" className="font-medium hover:underline" style={{ color: '#1A4D2E' }}>
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
